import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../api';
import './Register.css';

function VerifyOtp() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [digits, setDigits] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);
  const email = state?.email;

  useEffect(() => {
    if (!email) navigate('/register', { replace: true });
    else inputRefs.current[0]?.focus();
  }, [email, navigate]);

  const handleDigitChange = (index, value) => {
    const digit = value.replace(/\D/g, '').slice(-1);
    const nextDigits = [...digits];
    nextDigits[index] = digit;
    setDigits(nextDigits);
    setError('');
    if (digit && index < inputRefs.current.length - 1) inputRefs.current[index + 1]?.focus();
  };

  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace' && !digits[index] && index > 0) inputRefs.current[index - 1]?.focus();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const otp = digits.join('');
    if (otp.length !== 6) return setError('Enter all 6 digits');
    setLoading(true);
    setError('');
    setMessage('');
    try {
      const response = await axios.post(apiUrl('/api/auth/register/verify-otp'), { email, otp });
      setMessage(response.data.message);
      setTimeout(() => navigate('/login'), 1800);
    } catch (requestError) {
      setError(requestError.response?.data?.error || 'Verification failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!email) return null;

  return (
    <div className="register-container">
      <div className="register-box otp-box">
        <h1>Verify your email</h1>
        <p className="register-subtitle">Enter the 6-digit code sent to {email}</p>
        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit} className="register-form otp-form">
          <div className="otp-inputs" aria-label="Email verification code">
            {digits.map((digit, index) => (
              <input
                key={index}
                ref={(element) => { inputRefs.current[index] = element; }}
                type="text"
                inputMode="numeric"
                maxLength="1"
                value={digit}
                onChange={(event) => handleDigitChange(index, event.target.value)}
                onKeyDown={(event) => handleKeyDown(index, event)}
                disabled={loading}
                aria-label={`Verification digit ${index + 1}`}
              />
            ))}
          </div>
          <p className="verification-hint">This code expires in 15 minutes. You have 3 attempts.</p>
          <button type="submit" className="register-btn" disabled={loading || digits.join('').length !== 6}>
            {loading ? 'Verifying...' : 'Verify email'}
          </button>
        </form>
        <p className="login-link">Need a new code? <Link to="/register">Return to registration</Link></p>
      </div>
    </div>
  );
}

export default VerifyOtp;